// extracted by css-extract-rspack-plugin
export default {"ColorPill":"op30r","Selected":"LFBtk","Auto":"B5xnz","XSmall":"ZRoeU","Small":"t4pFO","Medium":"TTxJe","Large":"OHAfK"};